import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CampaignForm, { emptyCampaignForm, useCampaignFormSubmit } from '../../components/admin/CampaignForm';
import { PageTitle, PageSubtitle, Card, Btn, BtnRow, ErrorText } from '../../styles/adminStyles';
import { usePortalT } from '../../i18n/usePortalT';

export default function CampaignCreatePage() {
  const { t } = usePortalT();
  const [form, setForm] = useState(emptyCampaignForm);
  const { submit, saving, error } = useCampaignFormSubmit({ form, isEdit: false });

  return (
    <div>
      <PageTitle>{t('campaigns.createTitle')}</PageTitle>
      <PageSubtitle>{t('campaigns.createSubtitle')}</PageSubtitle>
      <Card>
        <CampaignForm form={form} onChange={setForm} />
        {error ? <ErrorText>{error}</ErrorText> : null}
        <BtnRow>
          <Btn $primary type="button" disabled={saving} onClick={() => void submit()}>
            {saving ? t('common.creating') : t('campaigns.createBtn')}
          </Btn>
          <Link to="/admin"><Btn type="button">{t('common.cancel')}</Btn></Link>
        </BtnRow>
      </Card>
    </div>
  );
}
